import React from "react";

export default function ThanksStep({ thanks }) {
  return (
    <div className="survey-step">
      <h2 className="survey-headline">{thanks.headline}</h2>
      {thanks.text && (
        <p className="survey-explanation">{thanks.text}</p>
      )}
    </div>
  );
}
